const appVersion = "2025.12.15";
export default appVersion;
//please do not edit the lines above